import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultApiConfig } from "./apiSettings";
import {
  AiDetectionSettings,
  UpdateAiDetectionSettingsBody,
} from "./aiDetectionSettings.types";

export const aiDetectionSettingsApi = createApi({
  ...defaultApiConfig,
  reducerPath: "aiDetectionSettingsApi",
  tagTypes: ["AiDetectionSettings"],
  endpoints: (builder) => ({
    getAiDetectionSettings: builder.query<AiDetectionSettings, void>({
      query: () => "admin/ai-detection-settings",
      providesTags: ["AiDetectionSettings"],
    }),
    updateAiDetectionSettings: builder.mutation<
      AiDetectionSettings,
      UpdateAiDetectionSettingsBody
    >({
      query: (body) => ({
        url: "admin/ai-detection-settings",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["AiDetectionSettings"],
    }),
  }),
});

export const {
  useGetAiDetectionSettingsQuery,
  useUpdateAiDetectionSettingsMutation,
} = aiDetectionSettingsApi;
